import { captureMiddlewareError } from './captureMiddlewareError'
import { captureMiddlewarePerformance } from './captureMiddlewarePerformance'
import { getMiddlewareHeaders } from './getMiddlewareHeaders'
import { getMiddlewareUrl } from './getMiddlewareUrl'
import { getSessionValue } from '../default/getSessionValue'

/**
 * Verifies a phone number
 * @param {string} phone - The phone number
 * @param {string} sessionId - The session ID
 * @returns {Promise<boolean>}
 */
export async function verifyPhoneInternal(phone, sessionId = 'tdMainFunnel') {
  const apiBase = getMiddlewareUrl()
  const endpoint = '/api/otp/send'
  const url = `${apiBase}${endpoint}`

  const startTime = performance.now()
  try {
    const funnel = getSessionValue(sessionId, 'funnel') || ''
    const affId = getSessionValue(sessionId, 'aff_id') || ''
    const utmCampaign = getSessionValue(sessionId, 'utm_campaign') || ''
    const trid = getSessionValue(sessionId, 'trid') || ''

    const body = JSON.stringify({
      phone,
      funnel,
      aff_id: utmCampaign || affId,
      trid,
    })
    const response = await fetch(url, {
      body,
      headers: getMiddlewareHeaders(),
      method: 'POST',
    })

    captureMiddlewarePerformance(url, performance.now() - startTime)

    if (response.ok) {
      const data = await response.json()
      const success = /** @type {boolean} */ (data.success)

      return success || false
    }

    throw Error(
      response.statusText || `${response.status}`.trim() || 'Unknown error',
    )
  } catch (error) {
    captureMiddlewarePerformance(url, performance.now() - startTime)
    captureMiddlewareError(url, /** @type {Error} */ (error))
    return false
  }
}
